(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["men-collection-template"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initMenCollectionSlider(root) {
      if (typeof Swiper === 'undefined') return;

      var context = root || document;
      var collectionWrap = context.querySelector('.custom-collection-wrap');
      if (!collectionWrap) return;

      var sliderEl = collectionWrap.querySelector('.collection-image-blocks.swiper');
      if (!sliderEl) return;

      // Clean up any existing instance to prevent double init
      if (sliderEl._swiperInstance) {
        sliderEl._swiperInstance.destroy(true, true);
        sliderEl._swiperInstance = null;
      }

      var paginationEl = sliderEl.querySelector('.swiper-pagination');
      var nextEl = sliderEl.querySelector('.swiper-button-next');
      var prevEl = sliderEl.querySelector('.swiper-button-prev');

      var swiper = new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        watchOverflow: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true
        } : false,
        navigation: (nextEl && prevEl) ? {
          nextEl: nextEl,
          prevEl: prevEl
        } : {},
        breakpoints: {
          750: {
            slidesPerView: 1
          }
        }
      });

      function updateHeaderFromActiveSlide(swiperInstance) {
        if (!swiperInstance || !swiperInstance.slides || swiperInstance.slides.length === 0) {
          document.body.removeAttribute('data-header');
          return;
        }

        var activeIndex = swiperInstance.activeIndex != null ? swiperInstance.activeIndex : 0;
        var activeSlide = swiperInstance.slides[activeIndex];
        if (!activeSlide) {
          document.body.removeAttribute('data-header');
          return;
        }

        var headerStyle = activeSlide.getAttribute('data-header-setting') || 'light';
        if (headerStyle) {
          document.body.setAttribute('data-header', headerStyle);
        } else {
          document.body.removeAttribute('data-header');
        }
      }

      swiper.on('init', function(swiperInstance) {
        updateHeaderFromActiveSlide(swiperInstance);
      });

      swiper.on('slideChange', function(swiperInstance) {
        updateHeaderFromActiveSlide(swiperInstance);
      });

      // Ensure header state is correct after initial layout
      updateHeaderFromActiveSlide(swiper);

      sliderEl._swiperInstance = swiper;
    }

    // Initialize on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initMenCollectionSlider(document);
      });
    } else {
      initMenCollectionSlider(document);
    }

    // Re-initialize on Shopify section load/reload (for theme editor)
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.custom-collection-wrap')) {
        setTimeout(function() {
          initMenCollectionSlider(event.target);
        }, 100);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["women-collection-template"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initWomenCollectionSlider(root) {
      if (typeof Swiper === 'undefined') return;

      var context = root || document;
      var collectionWrap = context.querySelector('.custom-collection-wrap');
      if (!collectionWrap) return;

      var sliderEl = collectionWrap.querySelector('.collection-image-blocks.swiper');
      if (!sliderEl) return;

      // Clean up any existing instance to prevent double init
      if (sliderEl._swiperInstance) {
        sliderEl._swiperInstance.destroy(true, true);
        sliderEl._swiperInstance = null;
      }

      var paginationEl = sliderEl.querySelector('.swiper-pagination');
      var nextEl = sliderEl.querySelector('.swiper-button-next');
      var prevEl = sliderEl.querySelector('.swiper-button-prev');

      var swiper = new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        watchOverflow: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true
        } : false,
        navigation: (nextEl && prevEl) ? {
          nextEl: nextEl,
          prevEl: prevEl
        } : {},
        breakpoints: {
          750: {
            slidesPerView: 1
          }
        }
      });

      function updateHeaderFromActiveSlide(swiperInstance) {
        if (!swiperInstance || !swiperInstance.slides || swiperInstance.slides.length === 0) {
          document.body.removeAttribute('data-header');
          return;
        }

        var activeIndex = swiperInstance.activeIndex != null ? swiperInstance.activeIndex : 0;
        var activeSlide = swiperInstance.slides[activeIndex];
        if (!activeSlide) {
          document.body.removeAttribute('data-header');
          return;
        }

        var headerStyle = activeSlide.getAttribute('data-header-setting') || 'light';
        if (headerStyle) {
          document.body.setAttribute('data-header', headerStyle);
        } else {
          document.body.removeAttribute('data-header');
        }
      }

      swiper.on('init', function(swiperInstance) {
        updateHeaderFromActiveSlide(swiperInstance);
      });

      swiper.on('slideChange', function(swiperInstance) {
        updateHeaderFromActiveSlide(swiperInstance);
      });

      // Ensure header state is correct after initial layout
      updateHeaderFromActiveSlide(swiper);

      sliderEl._swiperInstance = swiper;
    }

    // Initialize on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initWomenCollectionSlider(document);
      });
    } else {
      initWomenCollectionSlider(document);
    }

    // Re-initialize on Shopify section load/reload (for theme editor)
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.custom-collection-wrap')) {
        setTimeout(function() {
          initWomenCollectionSlider(event.target);
        }, 100);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
